import { TableLegendItem } from "./table/TableLegendItem";
import DeviceSettingStatus from '../constants/device-setting-status';
import { Translator } from "../contexts/translator";
import CustomSettingIcon from '../images/Custom Setting.svg';
import InheritPresetIcon from '../images/Inherited from Preset.svg';
import DisabledIcon from '../images/Disabled.svg';
import OfflineIcon from '../images/Offline.svg';
import OnlineIcon from '../images/Online.svg';
import UnknownIcon from '../images/Unknown.svg';
import DeviceStatus from '../constants/device-status';
import ActiveIcon from '../images/accounts_ticks_icon.svg';
import InActiveIcon from '../images/Disabled.svg';
import ActiveStatus from '../constants/status/active-status';

export const getDeviceSettingsTableLegendItems = (translate: Translator): TableLegendItem[] => {
    return [
        {
            value: DeviceSettingStatus.CustomSetting.id,
            imageIcon: CustomSettingIcon,
            label: translate.byKey(DeviceSettingStatus.CustomSetting.translationKey) ?? DeviceSettingStatus.CustomSetting.label,
            tooltip: translate.byKey(DeviceSettingStatus.CustomSetting.translationKey) ?? DeviceSettingStatus.CustomSetting.label
        },
        {
            value: DeviceSettingStatus.InheritPreset.id,
            imageIcon: InheritPresetIcon,
            label: translate.byKey(DeviceSettingStatus.InheritPreset.translationKey) ??  DeviceSettingStatus.InheritPreset.label,
            tooltip: translate.byKey(DeviceSettingStatus.InheritPreset.translationKey) ?? DeviceSettingStatus.InheritPreset.label
        }
    ];
};

export const getDeviceTableLegendItems = (translate: Translator) : TableLegendItem[]  => {
    
    return [
    {
        value: DeviceStatus.Unknown.id,
        imageIcon: UnknownIcon,
        label: translate.byKey(DeviceStatus.Unknown.translationKey) ?? DeviceStatus.Unknown.label,
        tooltip: translate.byKey(DeviceStatus.Unknown.translationKey) ?? DeviceStatus.Unknown.label // Same for now. May change.
    },
    {
        value: DeviceStatus.Offline.id,
        imageIcon: OfflineIcon,
        label: translate.byKey(DeviceStatus.Offline.translationKey) ?? DeviceStatus.Offline.label,
        tooltip: translate.byKey(DeviceStatus.Offline.translationKey) ?? DeviceStatus.Offline.label // Same for now. May change.
    },
    {
        value: DeviceStatus.Online.id,
        imageIcon: OnlineIcon,
        label: translate.byKey(DeviceStatus.Online.translationKey) ?? DeviceStatus.Online.label,
        tooltip: translate.byKey(DeviceStatus.Online.translationKey) ?? DeviceStatus.Online.label // Same for now. May change.
    },
    {
        value: DeviceStatus.Disabled.id,
        imageIcon: DisabledIcon,
        label: translate.byKey(DeviceStatus.Disabled.translationKey) ?? DeviceStatus.Disabled.label,
        tooltip: translate.byKey(DeviceStatus.Disabled.translationKey) ?? DeviceStatus.Disabled.label // Same for now. May change.
    }
]};

export const getActiveInactiveTableLegendItems = (translate: Translator): TableLegendItem[] => {
    return [
        {
            value: ActiveStatus.Active.id,
            imageIcon: ActiveIcon,
            label: translate.byKey(ActiveStatus.Active.translationKey) ?? ActiveStatus.Active.label,
            tooltip: translate.byKey(ActiveStatus.Active.translationKey) ?? ActiveStatus.Active.label // Same for now. May change.
        },
        {
            value: ActiveStatus.InActive.id,
            imageIcon: InActiveIcon,
            label: translate.byKey(ActiveStatus.InActive.translationKey) ?? ActiveStatus.InActive.label,
            tooltip: translate.byKey(ActiveStatus.InActive.translationKey) ?? ActiveStatus.InActive.label // Same for now. May change.
        }
    ]
};